import React from 'react';
import { Modal, Result, Button } from 'antd';
import DeleteIcon from '@mui/icons-material/Delete';
import { statusTokens } from '../../../theme/theme';

const ConfirmDeleteModal = ({
    isOpen,
    onClose,
    onConfirm,
    type, // 'product' or 'variant'
    itemName,
    loading = false
}) => {
    const getTitle = () => {
        return type === 'product' ? 'Delete Product' : 'Delete Variant';
    };

    const getSubTitle = () => {
        if (type === 'product') {
            return `Are you sure you want to delete the product "${itemName || 'Untitled'}"? This action will also delete all its variants and cannot be undone.`;
        } else {
            return `Are you sure you want to delete the variant "${itemName || 'Untitled'}"? This action cannot be undone.`;
        }
    };

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            centered
            footer={null}
            closable={!loading}
            maskClosable={!loading}
        >
            <Result
                icon={<DeleteIcon style={{ color: statusTokens.error, fontSize: '4rem' }} />}
                title={getTitle()}
                subTitle={getSubTitle()}
                extra={[
                    <Button
                        key="delete"
                        danger
                        type="primary"
                        onClick={onConfirm}
                        loading={loading}
                        disabled={loading}
                    >
                        Delete
                    </Button>,
                    <Button
                        key="cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default ConfirmDeleteModal; 